import { render, staticRenderFns } from "./ProfileTalentIndustries.vue?vue&type=template&id=558368c5"
import script from "./ProfileTalentIndustries.vue?vue&type=script&lang=js"
export * from "./ProfileTalentIndustries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports